"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploading = void 0;

//上传过程中
var uploading = function uploading(processing) {
  var processTxt;

  if (processing) {
    processTxt = /\%/.test(processing) ? processing : "".concat(processing, "%");
  } else {
    processTxt = "上传中, 请稍后...";
  }

  document.getElementsByClassName("process_cke")[0].innerText = processTxt;
};

exports.uploading = uploading;